<template>
  <el-popover placement="top" v-model="visible" ref="elPopover" :close-delay="0" popper-class="notes-popover">
    <div ref="popoverContainer" class="popover-container">
      {{ text }}
    </div>
  </el-popover>
</template>

<script>
import { debounce } from "@/plugins/util";

export default {
  name: "NotesPoppover",
  data() {
    return {
      id: "",
      text: "",
      visible: false,
      referenceElm: null,
      isOpen: false
    };
  },

  mounted() {
    window.addEventListener("mousemove", this.checkOtherArea);
  },
  beforeDestory() {
    window.removeEventListener("mousemove", this.checkOtherArea);
  },

  methods: {
    // 检查是否点击其他区域
    checkOtherArea: debounce(function(e) {
      if (this.isOpen) return;
      const target = e.target;
      const containerEl = this.$refs && this.$refs.popoverContainer;
      if (this.referenceElm && this.referenceElm.contains(target)) return;
      if (!(containerEl && containerEl.parentNode.contains(target))) {
        this.visible = false;
      }
    }, 200),
    showPopover: debounce(function(referenceElm, text) {
      this.text = text;
      this.isOpen = false;
      this.visible = true;
    }, 200),
    open(referenceElm, text) {
      this.isOpen = true;
      this.visible = false;
      this.$refs.elPopover.referenceElm = referenceElm;
      this.referenceElm = referenceElm;
      setTimeout(() => {
        this.showPopover(referenceElm, text);
      }, 20);
    },
    close() {
      this.visible = false;
      this.$refs.elPopover.referenceElm = null;
    }
  }
};
</script>

<style lang="less">
.notes-popover {
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  border-radius: 4px 4px 4px 4px;
  padding: 6px 7px;
}
.popover-container {
  max-width: 213px !important;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  line-height: 16px;
}
</style>
